import { useEffect, useRef, useState } from "react";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { getNodesForLessonProgress } from "api/services/node-service";
import { IGetNodeForLessonProgressRequest } from "api/models/request/IGetNodesForLessonProgressRequest";
import { IGetNodesForLessonProgressResponse } from "api/models/response/IGetNodesForLessonProgressResponse";
import { Node } from "models/Node";

export const useGetLessonProgressNodes = (lessonProgressId: string) => {
    const [nodes, setNodes] = useState<Node[]>([]);
    const { callAPI, loading } = useWorkspaceApiCall<IGetNodeForLessonProgressRequest, IGetNodesForLessonProgressResponse>(getNodesForLessonProgress, undefined, 'getNodesForLessonProgress.error');
    const hasCalledAPI = useRef(false);

    useEffect(() => {
        const fetchNodes = async () => {
            const resp = await callAPI({ lessonProgressId });
            if (resp?.success && resp.data?.nodes) {
                setNodes(resp.data.nodes);
            }
        }

        if (!lessonProgressId) {
            setNodes([]);
            return;
        }

        if (!hasCalledAPI.current) {
            hasCalledAPI.current = true;
            fetchNodes();
        }
    }, [lessonProgressId, callAPI, loading]);

    return { nodes, gettingNodes: loading };
}